module.exports = __webpack_public_path__ + "img/3.0efa7241.png";